import memoize from 'lodash.memoize';
import filterHtmlTags from './filterHtmlTags';

var normalizeSingleLanguageProperty = memoize(function (property, defaultLanguage) {
  if (!property) {
    return null;
  }
  if (typeof property === 'string') {
    return [{ '@language': defaultLanguage, '@value': filterHtmlTags(property) }];
  }
  if (Array.isArray(property)) {
    return null; // Invalid.
  }
  if (property['@value']) {
    property['@value'] = filterHtmlTags(property['@value']);
    // presentation 2.
    return [property];
  } else {
    // presentation 3.
    return Object.keys(property).reduce(function (acc, language) {
      if (Array.isArray(property[language])) {
        return [].concat(acc, property[language].map(function (value) {
          return {
            '@language': language === '@none' ? defaultLanguage : language,
            '@value': filterHtmlTags(value)
          };
        }));
      }
      return [].concat(acc, [{
        '@language': language === '@none' ? defaultLanguage : language,
        '@value': filterHtmlTags(property[language])
      }]);
    }, []);
  }
});

export default normalizeSingleLanguageProperty;